import { PrepareSvgForRasterization } from "./types";

export const prepareSvgForRasterization: PrepareSvgForRasterization = async ({
  svgElement,
}) => {
  // CLONE the SVG to avoid mutating the live UI
  const clonedSvg = svgElement.cloneNode(true) as SVGSVGElement;

  const images = clonedSvg.querySelectorAll("image");

  // Loop and inline images (fetch -> base64 -> embed)
  for (const imageTag of images) {
    const href =
      imageTag.getAttribute("href") || imageTag.getAttribute("xlink:href");

    if (href && (href.startsWith("http://") || href.startsWith("https://"))) {
      try {
        const response = await fetch(href);
        const blob = await response.blob();

        const reader = new FileReader();
        const base64Promise = new Promise<string>((resolve) => {
          reader.onloadend = () => resolve(reader.result as string);
          reader.readAsDataURL(blob);
        });

        const base64Data = await base64Promise;
        imageTag.setAttribute("href", base64Data);
      } catch (err) {
        console.warn("Failed to fetch and inline external image:", href, err);
      }
    }
  }

  const serializer = new XMLSerializer();
  const svgString = serializer.serializeToString(clonedSvg);

  const svgBlob = new Blob([svgString], {
    type: "image/svg+xml;charset=utf-8",
  });

  const svgUrl = URL.createObjectURL(svgBlob);

  return {
    svgUrl,
    svgProperties: {
      width: svgElement.clientWidth,
      height: svgElement.clientHeight,
    },
    revokeSvgUrl: () => URL.revokeObjectURL(svgUrl),
  };
};
